import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Translation, TranslocoLoader } from '@ngneat/transloco';

@Injectable({
    providedIn: 'root'
})
export class TranslocoHttpLoader implements TranslocoLoader {
    private _httpClient: HttpClient;
    /**
     * Constructor
     */
    constructor(
        private _handler: HttpBackend) {
        this._httpClient = new HttpClient(_handler);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get translation
     *
     * @param lang
     */
    getTranslation(lang: string): Observable<Translation> {
        lang = lang.toLowerCase()
        return this._httpClient.get<Translation>(`./assets/i18n/${lang}/${lang}.json`);
    }
}
